import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index';
import phone_index from '@/components/phone/phone_index';
import phone_viode from '@/components/phone/phone_video';
import phone_ppt from '@/components/phone/phone_ppt';
import phone_word from '@/components/phone/phone_word';
import pad_index from '@/components/pad/pad_index'
import pad_video from '@/components/pad/pad_video'
import pad_ppt from '@/components/pad/pad_ppt'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/phone_index',
      name: 'phone_index',
      component: phone_index
    },
    {
      path: '/phone_viode',
      name: 'phone_viode',
      component: phone_viode
    },  
    {
      path: '/phone_ppt',
      name: 'phone_ppt',
      component: phone_ppt
    },  
    {
      path: '/phone_word',
      name: 'phone_word',
      component: phone_word
    },  
    {
      path: '/pad_index',
      name: 'pad_index',
      component: pad_index
    },
    {
      path: '/pad_video',
      name: 'pad_video',
      component: pad_video
    },
    {
      path: '/pad_ppt',
      name: 'pad_ppt',
      component: pad_ppt
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js